declare global {
    interface Window {
      dataLayer: any;
    }
  }

const trackCartProductProtectionImpression = data => {
  const event = 'product_protection_cart_impression'

  const logData = {
    event,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackCartProductProtectionImpression
